export const experience = [
    {
        id: 1,
        order: 1,
        title: "Engineering Intern",
        dates: "Next Sep 2022 - Dec 2022",
        duties: ["Lorem ipsum dolor sit, amet consectetur adipisicing elit. Tenetur ullam modi incidunt maxime dolor ratione molestias amet mollitia doloremque ut molestiae at, fugit quae harum quibusdam magni omnis eum. Ipsam.",
        ],
        company: "Swfu"
    },
    {
        id: 2,
        order: 2,
        title: "Front-End Engineer",
        dates: "Next Jan 2023 - Jun 2023",
        duties: ["Lorem ipsum dolor sit, amet consectetur adipisicing elit. Tenetur ullam modi incidunt maxime dolor ratione molestias amet mollitia doloremque ut molestiae at, fugit quae harum quibusdam magni omnis eum. Ipsam.",
       ],
        company: "Chinese"
    },
    {
        id: 3,
        order: 3,
        title: "Full Stack Web Developer",
        dates: "Next Sep 2023 - Present",
        duties: [
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Tenetur ullam modi incidunt maxime dolor ratione molestias amet mollitia doloremque ut molestiae at, fugit quae harum quibusdam magni omnis eum. Ipsam.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Tenetur ullam modi incidunt maxime dolor ratione molestias amet mollitia doloremque ut molestiae at, fugit quae harum quibusdam magni omnis eum. Ipsam.",
        ],
        company: "Unknown"
    }
]